export { TestimonialWall } from "../cms-collections"
export type { TestimonialWallProps } from "../cms-collections"
